// extracted by mini-css-extract-plugin
module.exports = {"container":"RoomVolume_container__2rJO1","controllerContainer":"RoomVolume_controllerContainer__299NQ"};